import * as React from "react";
import {colors} from "@unibuddy/patron";
import {IconThumbUp} from "../../icons";
import {FeedbackButtonWrapper} from "./FeedbackButtonWrapper";

export type LikeButtonProps = {
    isLiked: boolean;
    onClick(): void | Promise<void>;
};

export const LikeButton = React.memo(({isLiked, onClick}: LikeButtonProps) => (
    <FeedbackButtonWrapper
        isActive={isLiked}
        fillColor={colors.teal800}
        onClick={onClick}
        aria-label="Like"
        ghost
    >
        <IconThumbUp color={colors.grey700} height={14} />
    </FeedbackButtonWrapper>
));
LikeButton.displayName = "LikeButton";
